/* eslint-disable react/prop-types */
import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCircle, faTrash } from '@fortawesome/free-solid-svg-icons';
import _ from 'lodash';
import { Button, Checkbox, Popconfirm, Table, Tooltip } from 'antd';

const getTableHeaders = ({ data, onDelete, tableHeadersPriorities }) => {
  let result = [];
  if (onDelete) result.push('DELETE');
  result = [...result, ...Object.keys(data[0])];

  if (tableHeadersPriorities) {
    result = _.sortBy(result, (x) => tableHeadersPriorities[x] || 0);
  }

  return result;
};

/*
    data - data which will be displayed
    selectKey - primary key which will be provided to "onSelect" function
    onSelect - function which will be called when anything will be selected by user
        as argument it will fetch "selectKey" value
    onDelete - function which will be called when user want to delete anything
        as first argument will be event
        as second argument will be item which should be deleted
 */
function CustomTable(props) {
  const {
    data: originalData,
    selectKey,
    onSelect,
    onSelectFull,
    formatNumbers = false,
    hiddenColumns = [],
    tableHeadersPriorities,
    tooltips,
    onDelete,
    onToggle,
  } = props;

  const [data, setData] = useState([]);

  useEffect(() => {
    setData(originalData || []);
  }, Object.values(props));

  if (!data || !data.length) return <div>No data</div>;

  const keys = getTableHeaders({ data, onDelete, tableHeadersPriorities }).filter((k) => !hiddenColumns.includes(k));

  const decorateValue = (raw) => {
    const value = (formatNumbers && raw) || raw;
    if (value === '+') return <FontAwesomeIcon icon={faCircle} size="xs" color="lightgreen" />;
    if (value === '-') return <FontAwesomeIcon icon={faCircle} size="xs" color="red" />;
    return value;
  };

  const columns = keys.map((k) => {
    const title = (
      <Tooltip title={_.get(tooltips, k)}>
        <span>{k === '__toggle' ? '' : k}</span>
      </Tooltip>
    );

    if (k === 'DELETE') {
      return {
        title,
        key: 'DELETE',
        width: 72,
        render: (_text, record) => (
          <Popconfirm
            title="Are you sure you want to delete it?"
            onConfirm={(e) => onDelete(e, record)}
            okText="Yes"
            cancelText="No"
          >
            <Button danger size="small">
              <FontAwesomeIcon icon={faTrash} size="sm" />
            </Button>
          </Popconfirm>
        ),
      };
    }

    if (k === '__toggle') {
      return {
        title,
        key: '__toggle',
        width: 60,
        render: (_text, record) => <Checkbox checked={Boolean(record.__toggle)} onChange={() => onToggle(record)} />,
      };
    }

    if (selectKey && onSelect && selectKey === k) {
      return {
        title,
        dataIndex: k,
        key: k,
        sorter: (a, b) => (a[k] > b[k] ? 1 : -1),
        render: (text, record) => (
          <Button type="link" onClick={() => (onSelectFull ? onSelect(record) : onSelect(record[selectKey]))}>
            {text}
          </Button>
        ),
      };
    }

    return {
      title,
      dataIndex: k,
      key: k,
      sorter: (a, b) => (a[k] > b[k] ? 1 : -1),
      render: (value) => decorateValue(value),
    };
  });

  return (
    <div style={{ overflowX: 'auto', width: '100%', maxHeight: 600 }}>
      <Table
        size="small"
        bordered
        pagination={false}
        rowKey={(_r, i) => String(i)}
        dataSource={data}
        columns={columns}
      />
    </div>
  );
}

CustomTable.propTypes = {
  data: PropTypes.array,
};

export default CustomTable;
